<template>
  <div class="Seleress">
    <div class="Seleress-background">
      <div class="appHelmetysen">收货地址<img src="../../public/obraoag/appReturn.png" alt="" @click="appHelmetreturn()"></div>
      <div class="Seleress-Recods" v-if="reslSeless">
        <div class="Seleress-Select">
          <el-checkbox v-model="seleched"></el-checkbox>
        </div>
        <div class="Seleress-adress">
          <div class="Seleress-Recods-left">
            <p class="Seleress-Recods-left-title">{{reslSeless.NAME}}<span>{{reslSeless.PHONE}}</span></p>
            <p class="Seleress-Recods-left-content">{{reslSeless.ADDRESS}}</p>
          </div>
          <div class="Seleress-Recods-right">
            <router-link :to="{path:'NewAddress',query: {selechanad: reslSeless.ID}}"><img src="../../public/obraoag/Setdmofy.png" alt=""></router-link>
          </div>
        </div>
      </div>
      <div class="Seleress-Recods" v-for="eireslNonult in reslNonult" :key="eireslNonult.ID">
        <div class="Seleress-Recods-left" @click="seleChanre(eireslNonult.ID)">
          <p class="Seleress-Recods-left-title">{{eireslNonult.NAME}}<span>{{eireslNonult.PHONE}}</span></p>
          <p class="Seleress-Recods-left-content">{{eireslNonult.ADDRESS}}</p>
        </div>
        <div class="Seleress-Recods-right">
          <router-link :to="{path:'NewAddress',query: {selechanad: eireslNonult.ID}}"><img src="../../public/obraoag/Setdmofy.png" alt=""></router-link>
        </div>
      </div>
      <router-link :to="{path:'NewAddress'}"><button class="Seleress-frame-confirm">+ 新建收货地址</button></router-link>
    </div>
  </div>
</template>


<script>
import "./obraojs/rem"
export default {
  data(){
    return{
      seleched: true,
      customerID: '',
      reslSeless: '',
      reslNonult: '',
      maluerID: ''
    }
  },
  created(){
    this.customerID = localStorage.getItem("usertoken");
    // 从缓冲中获取商城的标识
    this.maluerID = localStorage.getItem("usmago");
    // 通过拼接用户ID获取用户地址信息
    this.$axios.post('wx/addressList',this.$qs.stringify({
      MEMBER_ID: this.customerID,
      MALL_TYPE: this.maluerID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.reslSeless = res.data.default[0];
      this.reslNonult = res.data.notdefault;
    })
    .catch(() => {
      // console.log('未登录获取数据失败');
    });
  },
  mounted(){
     
  },
  methods:{
    // 修改默认地址
    seleChanre(SeressID){
      // 修改默认地址
      this.$axios.post('wx/addressUpdate',this.$qs.stringify({
        MEMBER_ID: this.customerID,
        ID: SeressID,
        DEFAULT_ADDRESS: '0',
        MALL_TYPE: this.maluerID
      }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
      .then(res => {
        if(res.data.result == 'success'){
          window.location.reload();
        }
      })
      .catch(() => {
        // console.log('未登录获取数据失败');
      });
    },
    // 点击返回上一层
    appHelmetreturn(){
      this.$router.go(-1);
    }
  }
}
</script>
<style scoped>
  @import "obraocs/Seleress.css";
</style>